var Tournaments = React.createClass({
    mixins: [React.addons.PureRenderMixin],

    render: function() {
        return (
            <div>
				<div>
					<h1>POP TOURNAMENTS</h1>
					<hr />
					From time to time we host game Tournaments. Here are the details. This document may be
					modified, so pay attention! In any case please write to us{' '}
					<a href="#u/mobcpop.com" className="white">
						mobcpop.com
					</a>{' '}
					♥.
					<br />
					<br />
					<h3>ACTIVE TOURNAMENTS</h3>
					<details open>
						<summary>Blockles</summary>
						<TournamentPoolRules />
						<br />
						<hr />
					</details>
					<br />
				</div>

				<div>
					<SeeAlso />
				</div>
			</div>
        )
    },
})